import { render, staticRenderFns } from "./Lgx173450318703493120.vue?vue&type=template&id=124d0d94&scoped=true&"
import script from "./Lgx173450318703493120.vue?vue&type=script&lang=js&"
export * from "./Lgx173450318703493120.vue?vue&type=script&lang=js&"
import style0 from "./Lgx173450318703493120.vue?vue&type=style&index=0&id=124d0d94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124d0d94",
  null
  
)

export default component.exports